import { useTranslation } from 'react-i18next';
import { StatCard } from '@/shared/ui';

import type { TransportStatsData } from '../../model/types';

interface TransportStatsProps {
  stats: TransportStatsData | null;
  isLoading: boolean;
}

export function TransportStats({ stats, isLoading }: TransportStatsProps) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <StatCard
        label={t('report_transportOverview_totalShipmentsLabel', 'Total Shipments')}
        value={stats?.totalShipments}
        isLoading={isLoading}
      />
      <StatCard
        label={t('report_transportOverview_totalTransportedLabel', 'Total Transported')}
        value={stats?.totalTransported}
        isLoading={isLoading}
      />
      <StatCard
        label={t('report_transportOverview_destinationsLabel', 'Destinations')}
        value={stats?.totalDestinations}
        isLoading={isLoading}
      />
      <StatCard
        label={t('welcome.chart.numberoflostordamaged.label', 'Loss & Damage')}
        value={
          <div className="text-sm font-medium space-y-1">
            <div className="text-destructive">Lost: {stats?.totalLoss}</div>
            <div className="text-orange-600">Damaged: {stats?.totalDamage}</div>
          </div>
        }
        isLoading={isLoading}
      />
    </div>
  );
}
